export const USER_DATA_RECEIVED = 'USER_DATA_RECEIVED'
export const USER_DATA_UNLOADED = 'USER_DATA_UNLOADED'
export const USER_INFO_RECEIVED = 'USER_INFO_RECEIVED'
export const USER_INFO_UNLOADED = 'USER_INFO_UNLOADED'
export const USER_RESTOREPOINT = 'USER_RESTOREPOINT'
export const PERSON_SAVED = 'PERSON_SAVED'
export const PRIMARY_SAVED = 'PRIMARY_SAVED'
export const PARTNER_SAVED = 'PARTNER_SAVED'
export const BOTH_USER_SAVED = 'BOTH_USER_SAVED'
export const USER_DEVICES_RECEIVED = 'USER_DEVICES_RECEIVED'
export const USER_DEVICES_DELETED = 'USER_DEVICES_DELETED'
export const USER_DEVICES_UNLOADED = 'USER_DEVICES_UNLOADED'
